import { ClassName } from 'types/props'

import icons from './icons'

export const vectorIconSize = {
  default: { height: '1em', width: '1em', fontSize: '1.5em' },
  small: { height: '0.65em', width: '0.65em', fontSize: '1.25em' },
  medium: { height: '1.25em', width: '1.25em', fontSize: '1.5em' },
  large: { height: '1.5em', width: '1.5em', fontSize: '1.75em' },
  xlarge: { height: '1.75em', width: '1.75em', fontSize: '1.75em' },
  xxxlarge: { height: '2.5em', width: '2.5em', fontSize: '2.5em' }
}

export interface IconProps extends ClassName {
  color?: string
  name: keyof typeof icons | string
  size?: keyof typeof vectorIconSize
}

const VectorIcon = ({ className, color, name, size }: IconProps) => {
  const sizeProps = size ? vectorIconSize[size] : vectorIconSize.default
  return (
    <svg
      className={className}
      style={{
        pointerEvents: 'none',
        color,
        ...sizeProps
      }}
      viewBox="0 0 24 24"
    >
      <title>{name}</title>
      <g>
        <path d={icons[name]} fill={color || 'currentColor'} fillRule="evenodd" />
      </g>
    </svg>
  )
}

export const Icon = ({ color, name, size, ...props }: IconProps) => (
  <VectorIcon color={color} name={name} size={size} {...props} />
)

export default Icon
